// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root___Q0Ah","wrapper":"Divider_wrapper__oRjof"};